export default __webpack_public_path__ + "static/media/gallery_03.c22eb4a5.jpg";